import React, { Component } from "react";
import * as s from "./Tag.module.scss";
import { DynamicLink } from "../DynamicLink";
import ConditionalWrapper from "../ConditionalWrapper/ConditionalWrapper";
import { P } from "../Paragraph";
import { truncate } from "src/libs/utils";
import { inject, observer } from "mobx-react";
import { UIStore } from "src/stores";
import { ICollectionSliderRow } from "src/models";
export interface TagProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  url?: string;
  active?: boolean;
  style?: any;
  size?: "small" | "medium" | "big";
  rounded?: boolean;
  disabled?: boolean;
  bordered?: boolean;
  uiStore?: UIStore;

  collectionId?: number;
  onChange?:
    | ((ISingleWordpressCollection, key) => void)
    | ((ISingleWordpressCollection, key, id?) => void);
  rows?: [ICollectionSliderRow] | any;
}

@inject("uiStore")
@observer
export class Tag extends Component<TagProps> {
  changeCollection = () => {
    const { onChange, collectionId, rows } = this.props;
    onChange(rows, collectionId);
  };
  render() {
    const {
      title,
      url,
      active,
      style,
      rounded,
      disabled,
      bordered,
      className,
      size,
      uiStore,
      collectionId,
      ...rest
    } = this.props;

    const { isDesktop } = uiStore;

    const classes = [s.tag];

    switch (size) {
      case "small":
        classes.push(s.small);
        break;
      case "medium":
        classes.push(s.medium);
        break;
      case "big":
        classes.push(s.big);
        break;
      default:
        classes.push(s.big);
    }

    if (rounded) {
      classes.push(s.rounded);
    }

    if (active) {
      classes.push(s.active);
    }

    if (bordered) {
      classes.push(s.bordered);
    }

    if (!url && className) {
      classes.push(className);
    }

    return (
      <ConditionalWrapper
        condition={url}
        wrapper={children => (
          <div
            onClick={() => {
              collectionId !== undefined && this.changeCollection();
            }}
            className={className}
            style={style}
          >
            {children}
          </div>
        )}
      >
        <div className={classes.join(" ")} {...rest}>
          <P medium={size === "big"}>{title}</P>
        </div>
      </ConditionalWrapper>
    );
  }
}
